import types from './types';

const defaultState = {
  isLoading: false,
  envRiskCalculation: 0,
  chemRiskCalculation: 0,
  envRiskResultDto: {},
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.ENV_RISK_CALCULATION:
      return { ...state, envRiskCalculation: state.envRiskCalculation + 1 };
    case types.CHEM_RISK_CALCULATION:
      return { ...state, chemRiskCalculation: state.chemRiskCalculation + 1 };

    default:
      return state;
  }
};
